const CampanaTypes = {
  SET_CAMPANAS: "SET_CAMPANAS",
  SET_CAMPANA_TARGETS: "SET_CAMPANA_TARGETS",
  SET_GRUPOS_SKUS: "SET_GRUPOS_SKUS"
};

export default CampanaTypes;
